




























import { Component, Vue } from 'vue-property-decorator'
import DefaultButton from '@/components/ui/DefaultButton.vue'
import NavigationButtons from '@/components/ui/NavigationButtons.vue'
import ShoppingCart from '@/components/ShoppingCart.vue'
import '@/icons/print'

@Component({
  components: {
    DefaultButton,
    NavigationButtons,
    ShoppingCart
  }
})
export default class Cart extends Vue {
  private print () {
    window.print()
  }
  private get previousRoute () {
    return this.$store.state.route.from.fullPath
  }
}
